import { getErrorMessageFromErrorType } from '@flowwai-frontend/shared/utils/common'
import { Thread } from '@flowwai-frontend/bps-officer-web/graphql'
import { ThreadModel } from '@flowwai-frontend/shared-web/ai-chat-support/data-access'

import { convertGqlThreadTypeToLocalThreadType } from '../../factories/threadMessageFactories'

import { CreateThreadMutation as Mutation } from './mutation.generatedTypes'

interface ResponseArgsType {
   data: Mutation
   onFailure?: (errorMessage: string, data: Mutation['createThread']) => void
   onSuccess?: (threadModel: ThreadModel) => void
}

interface ReturnType {
   handleAPIResponse: (args: ResponseArgsType) => void
}

const useAPIResponseHandler = (): ReturnType => {
   const handleAPIResponse = (args: ResponseArgsType): void => {
      if (!args.data) return
      const { createThread } = args.data

      switch (createThread.__typename) {
         case 'CreateThreadResult': {
            const formattedThreadData = convertGqlThreadTypeToLocalThreadType(
               createThread.thread as Thread
            )
            const threadModel = ThreadModel.create(formattedThreadData)
            args.onSuccess?.(threadModel)
            break
         }
         default: {
            const errorType = createThread.__typename
            const errorMessage = getErrorMessageFromErrorType(errorType)

            args.onFailure?.(errorMessage, createThread)
         }
      }
   }
   return { handleAPIResponse }
}

export default useAPIResponseHandler
